































import { Component, Prop, Vue, Emit } from 'vue-property-decorator'
import '@/icons/slider'

@Component({})
export default class Slider extends Vue {
  public $refs!: {
    button: HTMLElement
    slider: HTMLElement
  }
  @Prop({ default: 0 }) private min!: number
  @Prop({ default: 100 }) private max!: number
  @Prop() private value!: number

  private isDragging: boolean = false
  private buttonWidth: number = 0
  private sliderWidth: number = 0
  private maxPosition: number = 0
  private offset: number = 0
  private percentage: number = 0
  private currentValue: number = 0
  private isUpdated: boolean = false
  private zoom: number = 1
  @Emit('input')
  public onInput (value: number) { /**/ }

  private mounted () {
    this.getSize()
    this.getOffset()
    this.init()
    this.bindEvents()
  }

  private updated () {
    this.getSize()
  }

  private getSize () {
    const str = document.documentElement.style.zoom || '1'
    this.zoom = +str
    this.buttonWidth = this.$refs.button.clientWidth * this.zoom
    this.sliderWidth = this.$refs.slider.clientWidth * this.zoom
    this.maxPosition = this.sliderWidth - this.buttonWidth
  }

  private getOffset () {
    const rect = this.$refs.slider.getBoundingClientRect()
    this.offset = rect.left * this.zoom
  }

  private beforeDestroy () {
    this.unBindEvents()
  }

  private bindEvents () {
    document.addEventListener('touchmove', this.dragMove, { passive: false })
    document.addEventListener('touchend', this.dragUp, { passive: false })
    this.$refs.slider.addEventListener('touchstart', this.dragDown, { passive: false })
    this.$refs.slider.addEventListener('mousedown', this.dragDown)
    document.addEventListener('mousemove', this.dragMove)
    document.addEventListener('mouseup', this.dragUp)
    document.addEventListener('mouseleave', this.dragUp)
    window.addEventListener('resize', this.onResize)
  }

  private unBindEvents () {
    document.removeEventListener('touchmove', this.dragMove)
    document.removeEventListener('touchend', this.dragUp)
    this.$refs.slider.removeEventListener('touchstart', this.dragDown)
    this.$refs.slider.removeEventListener('mousedown', this.dragDown)
    document.removeEventListener('mousemove', this.dragMove)
    document.removeEventListener('mouseup', this.dragUp)
    document.removeEventListener('mouseleave', this.dragUp)
    window.removeEventListener('resize', this.onResize)
  }

  private onResize () {
    this.getSize()
    this.setValue(this.percentage)
  }

  private dragDown (e: MouseEvent | TouchEvent) {
    this.getOffset()
    this.isDragging = true
    this.dragMove(e)
  }

  private dragMove (e: MouseEvent | TouchEvent) {
    const event = 'targetTouches' in e ? e.targetTouches[0] : e

    if (this.isDragging) {
      const position = event.pageX - this.offset - this.buttonWidth / 2
      const percentage = (position / this.maxPosition) * 100

      this.setValue(percentage)
    }
  }

  private dragUp () {
    this.isDragging = false
  }

  private setValue (percentage: number) {
    if (percentage < 0) {
      percentage = 0
    }
    if (percentage > 100) {
      percentage = 100
    }
    this.percentage = percentage
    const position = (this.maxPosition / 100) * percentage
    this.$refs.button.style.left = (position / this.zoom) + 'px'
    const value = this.$props.min + (this.$props.max - this.$props.min) * (percentage / 100)
    const roundedValue = Math.round(value)
    if (roundedValue !== this.currentValue) {
      this.currentValue = roundedValue
      this.onInput(roundedValue)
    }
  }

  private init () {
    const percentage = (this.currentValue - this.$props.min) * 100 / (this.$props.max - this.$props.min)
    this.setValue(percentage)
  }
}
